import React, { memo, useEffect } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";

import Icon from "../Icons/Icon";

import "./HawkeyeV2Selection.scss";

function HawkeyeSelection(props) {
  const {
    onSelection,
    options,
    selectedOptions,
    isSearchable,
    className = "",
    renderSymbol,
  } = props;

  const [state, dispatch] = useAxiomState(
    {
      searchQuery: "",
    },
    props.appName,
    props.appID,
    "HawkeyeSelection",
    props.componentID
  );

  const { searchQuery } = state;

  // Reset search term on options change
  useEffect(() => {
    dispatch((state) => (state.searchQuery ? { searchQuery: "" } : null));
  }, [dispatch, options]);

  const onSearch = (event) => {
    const value = event.target.value;
    dispatch({ searchQuery: value });
  };

  return (
    <div className={className}>
      {options && options.length > 0 && isSearchable && (
        <div className={"hawkeye-selection-search"}>
          <input
            onChange={onSearch}
            value={searchQuery}
            className="hawkeye-selection-search-input"
            type="text"
          />
          <div className="hawkeye-selection-search-action" type="button">
            <Icon className="hawkeye-selection-search-icon" icon="ICON_SEARCH" />
          </div>
        </div>
      )}
      <nav className="hawkeye-selection-options">
        {options &&
          options.length > 0 &&
          options.map((option, index) => {
            let showOption = false;
            const isSelected = selectedOptions
              ? selectedOptions.some((d) => d.key == option.key)
              : false;
            if (searchQuery) {
              if (isMatching(option, searchQuery)) {
                showOption = true;
              }
            } else {
              showOption = true;
            }
            if (showOption) {
              if (renderSymbol && typeof renderSymbol == "function") {
                return renderSymbol(
                  index,
                  option.displayName,
                  () => onSelection(option),
                  option.key,
                  isSelected,
                  option.component
                );
              } else {
                return (
                  <button
                    key={index}
                    title={option.displayName}
                    onClick={() => onSelection(option)}
                    data-id={option.key}
                    className={
                      "hawkeye-action hawkeye-selection-item " + (isSelected ? "is-selected " : "")
                    }
                  >
                    {option.component ? option.component : `${option.displayName}`}
                  </button>
                );
              }
            }
          })}
      </nav>
    </div>
  );
}

function isMatching(option, searchQuery) {
  return (
    (option.displayName != null &&
      String(option.displayName).toLowerCase().includes(searchQuery.toLowerCase())) ||
    (option.key != null && String(option.key).toLowerCase().includes(searchQuery.toLowerCase()))
  );
}

export default memo(HawkeyeSelection);
